import React from "react";

const MaxCircle = ({ title, ...props }) => (
  <svg viewBox="0 0 390 390" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M153.1 31L195 62l41.9-31z" />
    <circle cx={264} cy={251} r={15} />
    <path d="M111 112v100c0 4.4 3.6 8 8 8h152c4.4 0 8-3.6 8-8V112c0-4.4-3.6-8-8-8H119c-4.4 0-8 3.6-8 8zM269.2 356H120.8l-10.1 14.9c25.5 12.2 54.1 19.1 84.3 19.1s58.8-6.9 84.3-19.1L269.2 356zM151.5 83c0 3.9 3.1 7 7 7h73c3.9 0 7-3.1 7-7s-3.1-7-7-7h-73c-3.9 0-7 3.1-7 7z" />
    <path d="M195 0C87.3 0 0 87.3 0 195c0 69.8 36.7 131 91.8 165.5l40.8-60.5H125c-16.6 0-30-13.4-30-30V92c0-16.6 13.4-30 30-30h56.5l-40.3-29.9-11.6 9.9c-1.7 1.4-4.2 1.2-5.6-.4-1.4-1.7-1.2-4.2.4-5.6l14-12c.7-.6 1.6-1 2.6-1h108c1 0 1.9.3 2.6 1l14 12c1.7 1.4 1.9 4 .4 5.6-.8.9-1.9 1.4-3 1.4-.9 0-1.8-.3-2.6-1l-11.6-9.9L208.5 62H265c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30h-7.6l40.8 60.5C353.3 326 390 264.8 390 195 390 87.3 302.7 0 195 0z" />
    <path d="M147.8 316h94.4l-10.8-16h-72.8zM261.1 344l-10.8-16H139.7l-10.8 16z" />
    <circle cx={126} cy={251} r={15} />
  </svg>
);

export default MaxCircle;
